import { render, staticRenderFns } from "./FriendReferrals.vue?vue&type=template&id=cbcbc93e&scoped=true&"
import script from "./FriendReferrals.vue?vue&type=script&lang=js&"
export * from "./FriendReferrals.vue?vue&type=script&lang=js&"
import style0 from "./FriendReferrals.vue?vue&type=style&index=0&id=cbcbc93e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcbc93e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BCardText, BFormInput, BButton, BInputGroupAppend, BInputGroup, BLink, BCard, BFormTextarea, BToast, BSpinner, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BCardText, BFormInput, BButton, BInputGroupAppend, BInputGroup, BLink, BCard, BFormTextarea, BToast, BSpinner, BForm, BContainer})
    

export default component.exports